import { CenterToJourneyRequestInput } from '../../lib/types/models/center-to-journey/center-to-journey-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type ComputeTripsMinMaxCapacityData = {
  tripId: number
  minCapacity: number
  maxCapacity: number
}

export const computeTripsMinMaxCapacity = async (input: CenterToJourneyRequestInput[]) => {
  return restApiClient
    .url(constructApiUrl(API.centers.computeTripsMinMaxCapacity.url, null))
    .post<ComputeTripsMinMaxCapacityData[], CenterToJourneyRequestInput[]>(input)
}
